import { locale } from 'devextreme/localization';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../../contexts/translation';
import useUnsavedChangesWarning from '../../hooks/useUnsavedChangesWarning';
import { Columns } from '../../pages/Assets/Columns/AssetTabParametersColumns';
import AssetParameterModal from '../modals/AssetParameterModal';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

export interface IAssetTabParameterDataGrid extends IDataGrid {
  isReadOnly?: boolean;
  parameterChanged: (rowData: any, value: any) => void;
  parameters: any;
  units: any;
  selectedUnitId?: number;
  handleNew: () => void;
  handleEdit: (e: any) => void;
  handleClose: () => void;
  modalVisibility: boolean;
  selectedData: any;
  selectedAction: any;
  onDataSubmit: (data: any, actionType: any) => void;
}

export const AssetTabParameterDataGrid = ({
  data,
  isReadOnly,
  parameterChanged,
  parameters,
  units,
  selectedUnitId,
  handleNew,
  handleEdit,
  handleClose,
  modalVisibility,
  selectedData,
  selectedAction,
  onDataSubmit,
}: IAssetTabParameterDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'Asset.Parameter';
  const { pathname } = useLocation();
  const [Prompt, setDirty, setClean] = useUnsavedChangesWarning(pathname);

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Asset parameters', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: handleNew,
          visible: !isReadOnly,
        },
      },
    );
  };

  const dateFormat = () => {
    if (locale() === 'cs-CZ' || locale() === 'sk-SK') return 'DD.MM.yyyy';
    else return 'DD/MM/yyyy';
  };

  const dateTimeFormat = () => {
    if (locale() === 'cs-CZ' || locale() === 'sk-SK') return 'DD.MM.yyyy HH:mm';
    else return 'DD/MM/yyyy HH:mm';
  };

  return (
    <>
      <SisDataGrid
        data={data}
        keyExpr={'id'}
        transFormName={transFormName}
        columns={Columns(
          translate,
          transFormName,
          handleEdit,
          isReadOnly,
          dateFormat,
          dateTimeFormat,
        )}
        onToolbarPreparing={onToolbarPreparing}
        columnChooser={false}
        allowColumnResizing={false}
        isReadOnly={isReadOnly}
        allowColumnReordering={false}
        prompt={Prompt}
      />
      {modalVisibility && (
        <AssetParameterModal
          isVisible={modalVisibility}
          selectedUnitId={selectedUnitId}
          parameterChanged={parameterChanged}
          data={selectedData ?? null}
          actionType={selectedAction}
          parameters={parameters}
          units={units}
          transFormName={transFormName}
          onSubmit={onDataSubmit}
          onClose={handleClose}
        />
      )}
    </>
  );
};
